import React from 'react';

export default function useContainerWidth(elementId: string, dependencies: any[]) {
  const [containerWidth, setContainerWidth] = React.useState(0);

  React.useEffect(() => {
    const element = document.getElementById(elementId);
    if (element) {
      setContainerWidth(element.clientWidth || 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies || []);

  return containerWidth;
}
